'use strict';

var Signal = require('signals');

var SHSignals = {
    /* ----------------------------------------------------------------------------- *\
       Common/Shared
    \* ----------------------------------------------------------------------------- */

    pageInitialized: new Signal(),
    referralInviteCancelled: new Signal(),
    referralStatusRequested: new Signal(),
    referralStatusRequestProcessed: new Signal(),
    socialUsersLoaded: new Signal(),
    socialUsersLoadErrored: new Signal(),
    modalClosed: new Signal(),
    promoCodeNotificationDataReceived: new Signal(),
    vehicleSelectFocused: new Signal(),
    mobileNavMenuToggled: new Signal(),
    recaptchaRespondedTo: new Signal(),

    /* ----------------------------------------------------------------------------- *\
       Analytics
    \* ----------------------------------------------------------------------------- */

    googleAdServicesScriptLoaded: new Signal(),

    /* ----------------------------------------------------------------------------- *\
       Referrals
    \* ----------------------------------------------------------------------------- */

    onInvitesSelected: new Signal(),
    onInvitesDismissed: new Signal(),
    onModalReferralFormProcessed: new Signal(),

    /* ----------------------------------------------------------------------------- *\
       Search
    \* ----------------------------------------------------------------------------- */

    searchIdsSet: new Signal(),
    spotHover: new Signal(),

    /* ----------------------------------------------------------------------------- *\
       Checkout
    \* ----------------------------------------------------------------------------- */

    checkoutUserAuthenticated: new Signal(),

    /* ----------------------------------------------------------------------------- *\
       Post Purchase
    \* ----------------------------------------------------------------------------- */

    receiptSurveyInitialized: new Signal(),

    /* ----------------------------------------------------------------------------- *\
       Account
    \* ----------------------------------------------------------------------------- */

    // account settings
    accountConfirmRemovalClosed: new Signal(),
    accountConfirmRemovalInitialized: new Signal(),
    accountPaymentTypeRemoved: new Signal(),
    accountLicensePlateRemoved: new Signal(),
    accountFavoriteRemoved: new Signal(),

    // account reservations
    accountReservationCancelled: new Signal(),
    accountReservationCancelFinished: new Signal(),
    accountReservationCancelError: new Signal(),
    accountReservationChanged: new Signal(),
    accountReservationDetailsRendered: new Signal(),
    accountReservationModalClosed: new Signal(),

    /* ----------------------------------------------------------------------------- *\
       User
    \* ----------------------------------------------------------------------------- */

    requestedLoginModal: new Signal()
};

window.SHSignals = SHSignals;

module.exports = SHSignals;



// WEBPACK FOOTER //
// ./spothero/static/main/js/events/sh-signals.js